export default {
    webMobileLogin: "/gateway/huilian/customermanagercs/messageLogin", //账号密码登录
    getRegisterCode: "/gateway/manageBedrock/messagecs/messageCode", //获取验证码
};



// WEBPACK FOOTER //
// ./src/invitation/modules/login/api.js